/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/training_xp': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 2l7 7-1.5 1.5L10 5 4.5 10.500 3 9zM10 9l7 7-1.5 1.5L10 12l-5.5 5.5L3 16z"/>'
  }
})
